import { countryService } from '../_services';

export const country = {
    namespaced: true,
    state: {
        all: [],
        ready: false
    },
    actions: {
        getCountryCollection({ commit }) {
            commit('getAllRequest');

            countryService.getCountryCollection()
                .then(
                    status => commit('getAllSuccess', status),
                    error => commit('getAllFailure', error)
                );
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
            state.ready = false;
        },
        getAllSuccess(state, status) {
            state.all = status['hydra:member'];
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.ready = false;
        }
    },
    getters: {
        showCountryCollection(state) {
            return state.all;
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
